//xhr that returns objects that look like fetch results, but still allows using events like progress

const buildResult = function(xhr){
  return {
    status: xhr.status,
    statusText: xhr.statusText,
    json: async () => JSON.parse(xhr.response)
  }
}

export default function fetchXhr(url, options){
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open(options.method, url);
    if (options.headers) {
      Object.entries(options.headers).forEach(([key, value]) => xhr.setRequestHeader(key, value));
    }
    if (options.credentials) {
      xhr.withCredentials = true;
    }
    if (options.events){
      Object.entries(options.events).forEach(([key, value]) => { xhr[key] = value });
    }
    xhr.onload = function () {
      if (options && options.events && options.events.onload && typeof options.events.onload === 'function'){
        options.events.onload();
      }
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(buildResult(xhr));
      } else {
        reject({ response: buildResult(xhr) });
      }
    }
    xhr.onerror = function () {
      if (options && options.events && options.events.onerror && typeof options.events.onerror === 'function'){
        options.events.onerror();
      }
      reject({ response: buildResult(xhr) });
    }
    xhr.send(options.body);
  });
}